import React from "react";

interface HeroProps {
  onOpenModal: () => void;
}

const Hero: React.FC<HeroProps> = ({ onOpenModal }) => {
  return (
    <header className="relative overflow-hidden">
      {/* Gradient Orbs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-indigo-400/20 to-blue-400/20 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute top-20 right-0 w-80 h-80 bg-gradient-to-bl from-emerald-400/20 to-blue-400/20 rounded-full blur-3xl translate-x-1/2 -translate-y-1/4"></div>
      
      <div className="container mx-auto px-4 py-20 md:py-32 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Main Heading - Only H1 on page */}
          <h1 className="text-5xl md:text-7xl font-extrabold text-slate-900 mb-8 animate-fade-in leading-tight">
            Stop Unexpected <span className="bg-gradient-to-r from-indigo-600 to-blue-600 bg-clip-text text-transparent">AI API Bills</span> Before They Happen
          </h1>
          
          {/* Subheading */}
          <p className="text-xl md:text-2xl text-slate-600 mb-10 max-w-3xl mx-auto leading-relaxed">
            Real-time cost monitoring and instant alerts for OpenAI, ChatGPT, and LLM APIs. Track usage, set budget limits, and prevent overspending—no technical expertise required.
          </p>
          
          {/* Primary CTA */}
          <button
            onClick={onOpenModal}
            className="inline-block bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-700 hover:to-blue-700 text-white font-semibold px-10 py-5 rounded-full text-lg transition-all transform hover:scale-105 hover:shadow-2xl shadow-xl"
          >
            Get Started Free
          </button>
          
          {/* Trust Badge */}
          <p className="mt-6 text-sm text-slate-500 flex items-center justify-center gap-2">
            <svg className="w-4 h-4 text-emerald-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            Privacy-first: We only read usage data, never your prompts or API requests
          </p>
        </div>
      </div>
    </header>
  );
};

export default Hero;
